export default __webpack_public_path__ + "static/media/zukunf_lauft_xl2.74fdaf30.png";